export default {
  meta: {
    title: '机会点报告pdf',
  }
};



